// extracted by mini-css-extract-plugin
module.exports = {"leftSide":"PlanFactGroupSubExpenditure_leftSide__2Cclf","field2":"PlanFactGroupSubExpenditure_field2__1Tiae","fieldGroup":"PlanFactGroupSubExpenditure_fieldGroup__3ALNX"};